import eventsClient from 'search-insights';

import { AlgoliaEventClientOptions, SearchIndexResult } from 'lib/search';

export function EventsClient(config: AlgoliaEventClientOptions) {
  eventsClient('init', {
    appId: config.algoliaAppId,
    apiKey: config.algoliaApiKey,
    authenticatedUserToken: config.userId,
  });

  return {
    sendResultSelectedEvent: function (
      selectedOperator: SearchIndexResult,
      position: number
    ) {
      eventsClient('clickedObjectIDsAfterSearch', {
        eventName: 'Operator Selected',
        index: config.algoliaIndexName,
        queryID: selectedOperator._queryId || 'unknownSearch',
        objectIDs: [selectedOperator.objectID],
        positions: [position],
      });
      // Also send a conversion event
      eventsClient('convertedObjectIDsAfterSearch', {
        eventName: 'Operator Converted',
        index: config.algoliaIndexName,
        queryID: selectedOperator._queryId || 'unknownSearch',
        objectIDs: [selectedOperator.objectID],
      });
    },
  };
}
